/* eslint-disable max-lines */
import { gql } from '@apollo/client';
import { graphql } from '../../../../gql';

export const GET_CONTROLLING_EINSTELLUNGEN_BY_STANDORT_ID = graphql(`
  query getControllingEinstellungenByStandortID($standortId: String!) {
    controlling(standortIds: [$standortId]) {
      einstellungen {
        absatzProduktivitaet {
          absatzVorgabe
          tagebuchAnzeige
          zielProduktivitaet
        }
        umsatzProduktivitaet {
          zielProduktivitaet
        }
      }
    }
  }
`);

export const GET_UMSATZ_ABSATZ_ZIELE_BY_STANDORT_ID = graphql(`
  query getUmsatzAbsatzZieleByStandortId(
    $standortId: String!
    $jahr: Int!
    $monat: Int!
  ) {
    controlling(standortIds: [$standortId]) {
      umsatzZiel(jahr: $jahr, monat: $monat) {
        ... on UmsatzZiel {
          jahrMonat {
            jahr
            monat
          }
          standortId
          umsatz {
            produktivitaet {
              currency
              amount
            }
            stunden
            wert {
              amount
              currency
            }
          }
        }
      }
      absatzZiel(jahr: $jahr, monat: $monat) {
        ... on controlling_AbsatzZiel {
          standortId
          absatz {
            produktivitaet {
              mpt
              stueck
            }
            stunden
            wert
          }
          jahrMonat {
            jahr
            monat
          }
        }
      }
    }
  }
`);

export const GET_UMSATZPLANUNG_SOLLSTUNDEN_BY_STANDORT_ID = graphql(`
  query getUmsatzplanungSollstundenByStandortId(
    $standortId: String!
    $jahr: Int!
    $monat: Int!
  ) {
    controlling(standortIds: [$standortId]) {
      sollstunden(jahr: $jahr, monat: $monat) {
        aushilfen
        festangestellt
      }
    }
  }
`);

export const GET_PLANWERTE_BY_STANDORT_ID = graphql(`
  query getPlanwerteByStandortId(
    $standortId: String!
    $jahr: Int!
    $monat: Int!
  ) {
    controlling(standortIds: [$standortId]) {
      planwerte(jahr: $jahr, monat: $monat) {
        datum
        standortId
        interneNotiz
        umsatzPlan {
          plan {
            produktivitaet {
              amount
              currency
            }
            stunden
            wert {
              amount
              currency
            }
          }
          prognose {
            amount
            currency
          }
        }
        absatzPlan {
          plan {
            produktivitaet {
              mpt
              stueck
            }
            stunden
            wert
          }
          prognose
        }
      }
    }
  }
`);

export const GET_TAGEBUCH_EINTRAEGE_BY_STANDORT_IDS = graphql(`
  query getTagebuchEintraegeByStandortIds(
    $standortIds: [String!]!
    $jahr: Int!
    $monat: Int!
    $temperaturEinheit: TemperaturEinheit!
  ) {
    controlling(standortIds: $standortIds) {
      standortId
      tagebuchEintrag(
        jahr: $jahr
        monat: $monat
        TemperaturEinheit: $temperaturEinheit
      ) {
        datum
        standortId
        wetter {
          datum
          uhrzeit
          niederschlagWahrscheinlichkeit
          wettercode
          wetterZustand
          maxTemperatur {
            einheit
            wert
          }
          minTemperatur {
            einheit
            wert
          }
        }
        interneNotiz
      }
    }
  }
`);

export const GET_HISTORIE_FOR_PLANWERTE_DIALOG = graphql(`
  query GetHistorieByStandortIdAndDatum($standortId: String!, $datum: String!) {
    historieByStandortIdAndDatum(standortId: $standortId, datum: $datum) {
      datum
      historie {
        current {
          datum
          interneNotiz
          istAbsatz {
            produktivitaet {
              mpt
              stueck
            }
            wert
          }
          planAbsatz {
            produktivitaet {
              mpt
              stueck
            }
            wert
          }
          istUmsatz {
            wert {
              amount
              currency
            }
            produktivitaet {
              amount
              currency
            }
          }
          planUmsatz {
            wert {
              amount
              currency
            }
            produktivitaet {
              amount
              currency
            }
          }
          wetter {
            code
            maxTemperatur
            minTemperatur
          }
        }
        prevWeek {
          datum
          interneNotiz
          istAbsatz {
            produktivitaet {
              mpt
              stueck
            }
            wert
          }
          planAbsatz {
            produktivitaet {
              mpt
              stueck
            }
            wert
          }
          istUmsatz {
            wert {
              amount
              currency
            }
            produktivitaet {
              amount
              currency
            }
          }
          planUmsatz {
            wert {
              amount
              currency
            }
            produktivitaet {
              amount
              currency
            }
          }
          wetter {
            code
            maxTemperatur
            minTemperatur
          }
        }
        prevMonth {
          datum
          interneNotiz
          istAbsatz {
            produktivitaet {
              mpt
              stueck
            }
            wert
          }
          planAbsatz {
            produktivitaet {
              mpt
              stueck
            }
            wert
          }
          istUmsatz {
            wert {
              amount
              currency
            }
            produktivitaet {
              amount
              currency
            }
          }
          planUmsatz {
            wert {
              amount
              currency
            }
            produktivitaet {
              amount
              currency
            }
          }
          wetter {
            code
            maxTemperatur
            minTemperatur
          }
        }
        prevYear {
          datum
          interneNotiz
          istAbsatz {
            produktivitaet {
              mpt
              stueck
            }
            wert
          }
          planAbsatz {
            produktivitaet {
              mpt
              stueck
            }
            wert
          }
          istUmsatz {
            wert {
              amount
              currency
            }
            produktivitaet {
              amount
              currency
            }
          }
          planUmsatz {
            wert {
              amount
              currency
            }
            produktivitaet {
              amount
              currency
            }
          }
          wetter {
            code
            maxTemperatur
            minTemperatur
          }
        }
      }
    }
  }
`);

export const MINDESTBELEGUNG_BY_STANDORT_ID_AND_DATUM = gql`
  query controlling_mindestbelegungByStandortIdAndDatum(
    $datum: String!
    $standortId: String!
  ) {
    controlling_mindestbelegungByStandortIdAndDatum(
      datum: $datum
      standortId: $standortId
    ) {
      dauer
    }
  }
`;
